import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root',
})
export class JwtService {

  getToken(): string {
    return window.localStorage.getItem('token');
  }

  saveToken(token: string) {
    window.localStorage.setItem('token', token);
  }

  destroyToken() {
    window.localStorage.removeItem('token');
  }

  getTokenAsSession(): string {
    return window.sessionStorage.getItem('token');
  }

  saveTokenAsSession(token: string) {
    window.sessionStorage.setItem('token', token);
  }

  destroyTokenAsSession() {
    window.sessionStorage.removeItem('token');
  }
}
